<template>
  <div xs12>
    <v-container fluid xs12>
      <v-layout class="xs12 mx-0 px-0 my-2 row wrap">
        <!-- <v-flex xs12>
          <v-subheader v-text="'Select artists who belong to this multi artist'"></v-subheader>
        </v-flex> -->
        <v-flex xs12 px-2>
          <v-text-field xs12
            :name="collective_name"
            placeholder="Collective Name"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 px-2>
          <v-autocomplete xs12
            :items="artists"
            v-model="multi_artists"
            label="Select artists who belong to this multi artist"
            item-text="name"
            item-value="id"
            chips
            deletable-chips
            multiple
          ></v-autocomplete>
        </v-flex>
      </v-layout>

      <v-layout xs12>
        <v-flex xs12>
          <v-data-iterator :items="multi_artists" item-key="id" item-value="id" row wrap hide-actions>
            <v-card slot="item" slot-scope="props" class="elevation-0 mb-3 mx-4">
              <!-- {{this.$store.state.artists}} -->
              <v-card-title class="title">{{ (ids2o ([props.item]))[0].name }}</v-card-title>
              <v-card-text v-if="ids2o ([props.item])[0].artworks">{{ ids2o ([props.item])[0].artworks.length }} artworks.</v-card-text>
            </v-card>
          </v-data-iterator>
        </v-flex>
      </v-layout>

    </v-container>
  </div>
</template>

<script>

  export default {
    data: function () {
      return {
        multi_artists: [],
        collective_name: '',
        artists: this.$store.state.artists
      }
    },
    methods: {
      ids2o (array) {
        if (array.length > 0) {
          var objs = Object.assign([], this.$store.state.artists)
          var out = objs.filter(a => {
            return (array.includes(a.id))
          })
          return out
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/artists/MultiArtist.vue